import { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'motion/react';

function PortalMock() {
  const subjects = [
    { name: 'Math', width: '72%' },
    { name: 'Science', width: '54%' },
    { name: 'Language Arts', width: '61%' },
    { name: 'Social Studies', width: '48%' },
  ];

  return (
    <div className="grid h-full grid-cols-1 gap-4 bg-[#f6f4ef] p-4 text-left md:grid-cols-[180px_1fr] md:p-6">
      <aside className="hidden rounded-2xl bg-[#1b365d] p-4 text-white md:block">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#e8d59a]">Portal</p>
        <ul className="mt-4 space-y-2 text-sm">
          {subjects.map((subject, index) => (
            <li
              key={subject.name}
              className={`rounded-xl px-3 py-2 ${index === 0 ? 'bg-white/15' : 'text-white/75'}`}
            >
              {subject.name}
            </li>
          ))}
        </ul>
      </aside>
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between rounded-2xl bg-white px-4 py-3 shadow-sm">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-[#c5a046]">Today</p>
            <p className="mt-1 text-lg font-semibold text-[#0f2137]" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Linear equations
            </p>
          </div>
          <div className="grid h-14 w-14 place-items-center rounded-full border-4 border-[#c5a046] text-sm font-bold text-[#1b365d]">
            68%
          </div>
        </div>
        <div className="grid flex-1 gap-3 sm:grid-cols-2">
          <div className="rounded-2xl bg-white p-4 shadow-sm">
            {subjects.map((subject) => (
              <div key={subject.name} className="mb-3 last:mb-0">
                <div className="mb-1 flex justify-between text-xs text-[#5b6570]">
                  <span>{subject.name}</span>
                </div>
                <div className="h-1.5 overflow-hidden rounded-full bg-[#e8eef6]">
                  <div className="h-full rounded-full bg-[#1b365d]" style={{ width: subject.width }} />
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col justify-end gap-2 rounded-2xl bg-[#0f2137] p-4 text-white">
            <p className="max-w-[16ch] self-end rounded-2xl rounded-br-md bg-white/10 px-3 py-2 text-sm">
              Why does this equation flip the sign?
            </p>
            <p className="max-w-[18ch] rounded-2xl rounded-bl-md bg-[#c5a046] px-3 py-2 text-sm text-[#0f2137]">
              You divide both sides. Let&apos;s do it together.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function HeroProductScroll() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'center start'],
  });
  const rotateX = useTransform(scrollYProgress, [0, 1], [18, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [0.88, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [48, 0]);

  const frame = (
    <div className="overflow-hidden rounded-[28px] border border-[#d9d3c5] bg-[#111] p-2 shadow-[0_30px_80px_rgba(15,33,55,0.18)] md:p-3">
      <div className="h-[420px] overflow-hidden rounded-[22px] md:h-[520px]">
        <PortalMock />
      </div>
    </div>
  );

  return (
    <section ref={ref} className="bg-[#f6f4ef] px-5 py-16 md:py-24" aria-label="Student portal preview">
      <div className="mx-auto mb-8 max-w-3xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#c5a046]">The portal</p>
        <h2
          className="mt-2 text-3xl text-[#0f2137] md:text-5xl"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.03em' }}
        >
          Lessons, progress, and the tutor on one screen.
        </h2>
      </div>
      <div className="mx-auto max-w-5xl" style={{ perspective: '1200px' }}>
        {reduce ? (
          frame
        ) : (
          <motion.div style={{ rotateX, scale, y, transformOrigin: 'center top' }}>{frame}</motion.div>
        )}
      </div>
    </section>
  );
}
